/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { enableProdMode } from '@angular/core';
import { environment , applyConfig } from './environments/environment';

// Renders a minimal, framework-free failure state. Used when the app cannot even
// bootstrap (e.g. runtime config failed to load), so it must not depend on Angular,
// app styles, or anything else that may not be available yet.
function showFatalStartupError(): void {
  const message = document.createElement('div');
  message.setAttribute('role', 'alert');
  message.style.cssText = 'display:flex;align-items:center;justify-content:center;min-height:100vh;padding:24px;font-family:Arial,Helvetica,sans-serif;text-align:center;box-sizing:border-box;';
  message.innerHTML = `
    <div>
      <h1 style="font-size:1.25rem;margin:0 0 8px;">Something went wrong</h1>
      <p style="margin:0 0 16px;color:#555;">Please refresh the page to try again.</p>
      <button type="button" id="app-startup-refresh-btn" style="padding:8px 24px;border:none;border-radius:20px;background-color:#e10a1d;color:#fff;font-size:1rem;cursor:pointer;">Refresh</button>
    </div>
  `;

  const appRoot = document.querySelector('app-root');
  if (appRoot?.parentElement) {
    appRoot.replaceWith(message);
  } else {
    document.body.appendChild(message);
  }

  document.getElementById('app-startup-refresh-btn')?.addEventListener('click', () => {
    window.location.reload();
  });
}

fetch('./assets/config/config.json')
  .then(response => {
    if (!response.ok) {
      throw new Error(`Failed to load config.json: ${response.status} ${response.statusText}`);
    }
    return response.json();
  })
  .then(data => {
    const hostKey = location.hostname.toLowerCase().trim();
    const hostConfig = data?.[hostKey];
    if (!hostConfig) {
      throw new Error(`No application configuration found for host "${hostKey}"`);
    }
    applyConfig(hostConfig);
    if (environment.production) {
      enableProdMode();
    }
    return bootstrapApplication(AppComponent, appConfig);
  })
  .catch((err) => {
    console.error('Application failed to start:', err);
    showFatalStartupError();
  });

